const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const Menu = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domMenuBtn: $('.js-menu-btn'),
	$domMenuOuter: $('.js-nav-outer'),
	$domMenuInner: $('.js-nav-inner'),
	$domMenuIcon: $('.js-nav-icon'),
	$domMenuSub: $('.sub-menu'),
	slMenuIcon: '.js-nav-icon',
	slMenuSub: '.sub-menu',
	classActive: 'is-active',
	classFixed: 'prevent-scroll',
	timeout: null,

	/** @description Initialize */
	init: function() {
		this.bindEvents();
		this.moveHeaderBottom();
		// if ($(window).width() > 1199) {
		// 	this.linksOnDesktop();
		// }
		if ($(window).width() < 768) {
			this.searchHideShow();
		}
		if ($(window).width() < 1200) {
			$('#menu-secondary .menu-item-has-children').each(function() {
				$(this).on('click', function(e) {
					e.preventDefault();
					$('#menu-secondary .sub-menu').not($(this).children('.sub-menu')).slideUp();
					$(this).children('.sub-menu').slideToggle();
				});
			});

			$('#menu-secondary .sub-menu').on('click', function(e) {
				e.stopPropagation();
			});
		}
		$(window).on('resize', () => {
			this.moveHeaderBottom();
			// if ($(window).width() > 1199) {
			// 	this.linksOnDesktop();
			// }
			if ($(window).width() < 768) {
				this.searchHideShow();
			}
			if ($(window).width() < 1200) {
				$('#menu-secondary .menu-item-has-children').each(function() {
					$(this).on('click', function(e) {
						e.preventDefault();
						$('#menu-secondary .sub-menu').not($(this).children('.sub-menu')).slideUp();
						$(this).children('.sub-menu').slideToggle();
					});
				});
				$('#menu-secondary .sub-menu').on('click', function(e) {
					e.stopPropagation();
				});
			}
		});
	},

	/** @description Bind Events */
	bindEvents: function() {
		this.$domMenuBtn.on('click', this.toggleMenu.bind(this));
		this.$domMenuIcon.on('click', this.toggleSubMenu.bind(this));
		Global.escKey(this.closeMenu.bind(this));
		Global.clickOutsideContainer(Global.$domBody, this.$domMenuInner, this.$domMenuBtn, this.closeMenu.bind(this));
	},

	toggleMenu: function() {
		if (!this.$domMenuBtn.hasClass(this.classActive)) {
			this.$domMenuBtn.addClass(this.classActive);
			this.$domMenuOuter.addClass(this.classActive);
			Global.$domBody.addClass(this.classFixed);
		} else {
			this.closeMenu();
			Global.$domBody.removeClass(this.classFixed);
		}
	},

	toggleSubMenu(e) {
		e.preventDefault();
		e.stopPropagation();

		const $icon = $(e.target).closest(this.slMenuIcon);
		const $submenu = $icon.siblings(this.slMenuSub);
		const isActive = $icon.hasClass(this.classActive);

		$icon.toggleClass(this.classActive, !isActive);
		$submenu.stop(true, true)[isActive ? 'slideUp' : 'slideDown']();
	},

	closeMenu: function() {
		this.$domMenuBtn.removeClass(this.classActive);
		this.$domMenuOuter.removeClass(this.classActive);
		Global.$domBody.removeClass(this.classFixed);

		// timeout should match the selectors CSS transition duration property
		clearTimeout(this.timeout);
		this.timeout = setTimeout(() => {
			this.$domMenuIcon.removeClass(this.classActive);
			this.$domMenuSub.slideUp();
		}, 300);
	},

	linksOnDesktop: function() {
		// $('li.menu-item-has-children').each(function(e, el) {
		// 	$(el).on('click', function(event) {
		// 		event.stopPropagation();

		// 		if ($(el).children('.sub-menu').first().hasClass('is-visible')) {
		// 			$(el).children('.sub-menu').first().removeClass('is-visible');
		// 		} else {
		// 			$('li.menu-item-has-children .sub-menu').removeClass('is-visible');
		// 			$(el).children('.sub-menu').first().addClass('is-visible');
		// 		}
		// 	});
		// });
		$('li.menu-item-has-children').each(function(e, el) {
			$(el).on('click', function(event) {
				event.stopPropagation();
				if ($(el).parents('.sub-menu').length > 0) {
					return;
				}

				if ($(el).children('.sub-menu').first().hasClass('is-visible')) {
					$(el).children('.sub-menu').first().removeClass('is-visible');
				} else {
					$('li.menu-item-has-children > .sub-menu').removeClass('is-visible');
					$(el).children('.sub-menu').first().addClass('is-visible');
				}
			});
		});

		$('.sub-menu').on('click', function(event) {
			event.stopPropagation();
		});

		$('.sub-menu li.menu-item-has-children').on('click', function(event) {
			event.stopPropagation();
		});

		$(document).on('click', function(event) {
			if (!$(event.target).closest('li.menu-item-has-children').length && !$(event.target).closest('.sub-menu').length) {
				$('li.menu-item-has-children .sub-menu').removeClass('is-visible');
			}
		});
	},

	moveHeaderBottom: function() {
		const isMobile = window.innerWidth < 1200;
		const isInMobile = $('.site-header__top-bar-nav').closest('.js-nav-inner').length > 0;

		if (isMobile && !isInMobile) {
			$('.site-header__top-bar-nav').prependTo('.js-nav-inner');
			$('.site-header__menu').appendTo('.js-nav-inner');
		} else if (!isMobile && isInMobile) {
			$('.site-header__top-bar-nav').prependTo('.site-header__top-bar-nav-wrap');
			$('.site-header__menu').insertAfter('.site-header__search');
		}
	},

	searchHideShow: function() {
		$(document).ready(function($) {
			$('.site-header__nav-search-resp').on('click', function(e) {
				e.stopPropagation();
				$('.site-header__search').toggleClass('is-visible');
			});

			$(document).on('click', function(e) {
				if (!$(e.target).closest('.site-header__search, .site-header__nav-search-resp').length) {
					$('.site-header__search').removeClass('is-visible');
				}
			});
		});
	}
};

export default Menu;
